import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QUALITATIVE_RUBRICS, nearestRubricValue } from "@/lib/qualitativeRubric";

/**
 * MaturityDropdown — qualitative rubric dropdown for the 6 qualitative
 * parameters (ecosystem, risk, social, certifications, governance, economic).
 *
 * Internally still emits a numeric value (2 / 5 / 10) so the backend
 * calculation logic remains unchanged.
 *
 * Props:
 *  - paramKey: one of QUALITATIVE_PARAMS
 *  - value: current numeric score (number or "")
 *  - onChange: (numericValue: number) => void
 *  - testId: optional data-testid
 *  - size: "sm" | "md" (default md)
 */
export default function MaturityDropdown({ paramKey, value, onChange, testId, size = "md", className = "" }) {
  const rubric = QUALITATIVE_RUBRICS[paramKey];
  if (!rubric) return null;

  // Snap any numeric value to nearest {2,5,10} so existing data still maps
  const snapped = value === "" || value === null || value === undefined ? null : nearestRubricValue(paramKey, value);
  const currentStr = snapped === null ? "" : String(snapped);

  const heightClass = size === "sm" ? "h-8 text-xs" : "h-9 text-sm";

  return (
    <Select value={currentStr} onValueChange={(v) => onChange(parseFloat(v))}>
      <SelectTrigger
        className={`border-[#E0E6E1] ${heightClass} ${className}`}
        data-testid={testId}
      >
        <SelectValue placeholder="Select maturity..." />
      </SelectTrigger>
      <SelectContent className="max-w-[420px]">
        {rubric.options.map((opt) => (
          <SelectItem key={opt.value} value={String(opt.value)} className="text-xs whitespace-normal py-2">
            <span className="text-[#1B291D]">{opt.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
